import userResources from "api/userResources";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout, selectUserInfo } from "../../redux/userSlice";
import { MdLock } from "react-icons/md";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);

  // function to send message before logout
  const sendMessage = async () => {
    if (userInfo?.data?.id === 16) return;

    const messageData = {
      message: "I'm Logout",
      receiver_id: 16,
    };
    try {
      const res = await userResources.sendMsg(messageData);
      if (res.status) {
        console.log("Logout message sent!");
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleLogout = async () => {
    const toastId = toast.loading("Logging out...");

    try {
      // ✅ 1. Send message before logout
      await sendMessage();

      // ✅ 2. Call the markAttendance API
      const response = await userResources.markAttendance();

      if (response.status) {
        // ✅ 3. Logout API
        await userResources.logout();
      }

      // ✅ 4. Clear user state
      dispatch(logout());

      // ✅ 5. Success toast
      toast.update(toastId, {
        render: "You've successfully logged out! See you next time!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      // ✅ 6. Redirect to home
      navigate("/");
    } catch (error) {
      toast.update(toastId, {
        render: "Logout failed. Please try again.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error("Logout failed:", error);
    }
  };

  return (
    <div>
      <li
        onClick={handleLogout}
        className="mx-8 flex cursor-pointer font-semibold "
      >
        <MdLock className="mr-4 h-6 w-6 text-red-500 dark:text-red-500" />
        <p className="text-lg text-red-500 hover:text-red-700">Logout</p>
      </li>
    </div>
  );
}
